import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Nfts from "../../components/Nfts";
import { Etherium, Loader } from "../../constant/Index";
import { clearNFt_ID, setNFt_ID } from "../../store/reducer/NftReducers";
import {
	useNftContentQuery,
	useNftsContentQuery,
} from "../../store/services/NftTypeService";
let ImgUrl = "https://lend-me-token.developer-ourbase-camp.com/uploads/";

const Explore = () => {
	let { Nft_id } = useSelector((state) => state.NftReducers);
	// let [Nft_id, setNFt_ID] = useState();
	const [currentPageState, setcurrentPageState] = useState(1);
	let datas = {
		Nft_id,
		currentPageState,
	};
	const { data: nftsDatas, isLoading, error } = useNftsContentQuery(datas);
	const { data, isLoading: load } = useNftContentQuery();
	let Nftresponse = nftsDatas?.response?.data?.data;
	const [clearPage, setClearPage] = useState(false);
	let response = data?.response?.data;
	let total = nftsDatas?.response?.data?.total;
	let limit = nftsDatas?.response?.data?.per_page;
	const pages = Math.ceil(total / limit);
	const handlePageClick = (data) => {
		let currentPage = data.selected + 1;
		setcurrentPageState(currentPage);
	};

	let dispatch = useDispatch();
	const handleClick = (id) => {
		setClearPage(true);
		dispatch(setNFt_ID(id));
		setcurrentPageState(1);
	};
	useEffect(() => {
		return () => {
			dispatch(clearNFt_ID());
		};
	}, []);
	// let total = data?.response?.data?.total;
	// let limit = data?.response?.data?.per_page;
	// const pages = Math.ceil(total / limit);
	// const handlePageClick = (data) => {
	// 	let currentPage = data.selected + 1;
	// 	setcurrentPageState(currentPage);
	// };
	return (
		<>
			{/* Header Sec Start Here */}
			<Header />
			{/* Header Sec End Here */}

			{/* <!-- NFT Collection Sec Start Here --> */}
			<section className="nft_collections explore-nfts">
				<div className="glowing glowing-left">
					<span></span>
				</div>
				<div className="container">
					<div className="heading-wrapper text-center">
						<h4>LEND ME TOKEN</h4>
						<h2>OUR NFT COLLECTION</h2>
						<p>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
							eiusmod tempor incididunt ut labore et dolore
						</p>
					</div>
					<nav>
						<div className="nav nav-tabs" id="nav-tab" role="tablist">
							{response?.map((data, index) => {
								return (
									<button
										key={data?.id}
										onClick={() => handleClick(data?.id)}
										className="nav-link"
										id={`nav-nft1-tab${index + 1}`}
										data-bs-toggle="tab"
										data-bs-target={`#nav-nft1${index + 1}`}
										type="button"
										role="tab"
										aria-controls={`nav-nft1${index + 1}`}
										aria-selected="true"
									>
										{data?.name}
									</button>
								);
							})}
							{/* <button
								className="nav-link"
								id="nav-nft2-tab"
								data-bs-toggle="tab"
								data-bs-target="#nav-nft2"
								type="button"
								role="tab"
								aria-controls="nav-nft2"
								aria-selected="false"
							>
								NFTS # 1
							</button>
							<button
								className="nav-link"
								id="nav-nft3-tab"
								data-bs-toggle="tab"
								data-bs-target="#nav-nft3"
								type="button"
								role="tab"
								aria-controls="nav-nft3"
								aria-selected="false"
							>
								NFTS # 1
							</button>
							<button
								className="nav-link"
								id="nav-nft4-tab"
								data-bs-toggle="tab"
								data-bs-target="#nav-nft4"
								type="button"
								role="tab"
								aria-controls="nav-nft4"
								aria-selected="false"
							>
								NFTS # 1
							</button> */}
						</div>
					</nav>
					<div className="row justify-content-center">
						{/* <Nfts
							currentPageState={currentPageState}
							someData={someData}
							clearPage={clearPage}
						/> */}
						{!isLoading ? (
							<>
								{error?.status !== 400 &&
									Nftresponse?.map((nftdata, index) => {
										return (
											<div className="col-lg-3 col-md-6" key={index}>
												<div className="nft-box wow animate__animated animate__bounceIn">
													<a href={nftdata?.link} target="_blank">
														<div className="nft-image">
															<figure>
																<img
																	src={`${ImgUrl}${nftdata?.image}`}
																	alt=""
																	className="img-fluid"
																/>
															</figure>
														</div>
														<div className="nft-content">
															<h4 className="name">{nftdata?.title}</h4>
															<div className="price">
																<figure>
																	<img
																		src={Etherium}
																		alt="123"
																		className="img-fluid"
																	/>
																</figure>
																<h4>{nftdata?.price}</h4>
															</div>
														</div>
													</a>
												</div>
											</div>
										);
									})}
								{error?.status === 400 ? (
									<div className="not-found">
										<h3>Nft Not Found</h3>
									</div>
								) : (
									Nftresponse?.length > 11 && (
										<div className="paginations">
											<ReactPaginate
												breakLabel="..."
												nextLabel=">"
												previousLabel="<"
												onPageChange={handlePageClick}
												marginPagesDisplayed={0}
												pageRangeDisplayed={4}
												pageCount={pages}
											/>
										</div>
									)
								)}
							</>
						) : (
							<div
								className="loader"
								style={{ margin: "0px auto", textAlign: "center" }}
							>
								<img
									src={Loader}
									style={{ margin: "0px auto" }}
									alt=""
									className="img-fluid"
								/>
							</div>
						)}
					</div>
					{/* <div className="tab-content" id="nav-tabContent">
						<div
							className="tab-pane fade show active"
							id="nav-nft1"
							role="tabpanel"
							aria-labelledby="nav-nft1-tab"
						>
							<div className="row"></div>
						</div>
						<div
							className="tab-pane fade"
							id="nav-nft2"
							role="tabpanel"
							aria-labelledby="nav-nft2-tab"
						>
							<div className="row">
								<Nfts />
							</div>
						</div>
						<div
							className="tab-pane fade"
							id="nav-nft3"
							role="tabpanel"
							aria-labelledby="nav-nft3-tab"
						>
							<div className="row">
								<Nfts />
							</div>
						</div>
						<div
							className="tab-pane fade"
							id="nav-nft4"
							role="tabpanel"
							aria-labelledby="nav-nft4-tab"
						>
							<div className="row">
								<Nfts />
							</div>
						</div>
					</div> */}
					{/* <div className="paginations">
						<ReactPaginate
							breakLabel="..."
							nextLabel=">"
							previousLabel="<"
							onPageChange={handlePageClick}
							marginPagesDisplayed={0}
							pageRangeDisplayed={4}
							pageCount={pages}
						/>
					</div> */}
					{/* <ul className="paginations">
						<li>
							<a href="#" className="active">
								01
							</a>
						</li>
						<li>
							<a href="#">02</a>
						</li>
						<li>
							<a href="#">03</a>
						</li>
						<li>
							<a href="#">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="18.004"
									height="9.565"
									viewBox="0 0 18.004 9.565"
								>
									<path
										id="Path_4396"
										data-name="Path 4396"
										d="M-472.936,93.2a4.075,4.075,0,0,1-.26.317q-1.841,1.846-3.686,3.688a.4.4,0,0,1-.561.077.368.368,0,0,1-.071-.517,1.68,1.68,0,0,1,.167-.184q1.461-1.463,2.924-2.923a1.458,1.458,0,0,1,.143-.112l-.023-.055h-15.065a1.391,1.391,0,0,1-.28-.024.374.374,0,0,1-.292-.373.376.376,0,0,1,.293-.357,1.442,1.442,0,0,1,.28-.023h15.1c-.072-.077-.115-.123-.159-.168q-1.5-1.5-2.993-3a.415.415,0,0,1-.141-.474A.377.377,0,0,1-477,88.9a1.466,1.466,0,0,1,.184.167q1.809,1.807,3.616,3.617a4,4,0,0,1,.259.317Z"
										transform="translate(490.439 -88.328)"
										fill="#fff"
										stroke="#fff"
										strokeWidth="1"
									/>
								</svg>
							</a>
						</li>
					</ul> */}
				</div>
				<div className="glowing glowing-right">
					<span></span>
				</div>
			</section>
			{/* <!-- NFT Collection Sec End Here --> */}

			{/* Footer Sec Start Here */}
			<Footer />
			{/* Footer Sec End Here */}
		</>
	);
};

export default Explore;
